import React, { useState, useEffect } from 'react';
import { ref, onValue, get, update, push, query, limitToFirst } from "firebase/database";
import { db } from "../firebase";
import './TradePanel.css';

const TradePanel = ({ coinSymbol, currentPrice }) => {
  const [time, setTime] = useState('30s');
  const [amount, setAmount] = useState('0.00');
  const [walletBalance, setWalletBalance] = useState(0); 
  const [totalLivePnL, setTotalLivePnL] = useState(0); 
  const [isExecuting, setIsExecuting] = useState(false);

  const savedUser = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    if (!savedUser?.username) return;
    
    const userRef = ref(db, 'users/' + savedUser.username);
    const unsubUser = onValue(userRef, (snapshot) => {
      const data = snapshot.val();
      if (data) setWalletBalance(parseFloat(data.balance || 0));
    });

    const activeRef = ref(db, `activePositions/${savedUser.username}`);
    const unsubActive = onValue(activeRef, (snapshot) => {
      const trades = snapshot.val();
      if (trades) {
        let pnlSum = 0;

        Object.values(trades).forEach(t => {
          // ✅ finalized trades ka pnl include nahi hoga (fix spike issue)
          if (!t.finalized) {
            pnlSum += parseFloat(t.currentLivePnL || 0);
          }
        });

        setTotalLivePnL(pnlSum);
      } else {
        setTotalLivePnL(0);
      }
    });

    return () => { unsubUser(); unsubActive(); };
  }, [savedUser.username]);

  const handleTradeAction = async (direction) => {
    const investAmount = parseFloat(amount);

    // ✅ FIX: live balance include karo (wallet + livePnL)
    if (!investAmount || investAmount <= 0 || investAmount > (walletBalance + totalLivePnL) || isExecuting) {
      return alert("Invalid Amount or Insufficient Balance!");
    }

    setIsExecuting(true);
    try {
      const userDbKey = savedUser.username;
      const queueRef = query(ref(db, `tradingControl/${userDbKey}/queues`), limitToFirst(1));
      const queueSnapshot = await get(queueRef);
      
      let targetPnL = 0;
      let queueIdToDelete = null;

      if (queueSnapshot.exists()) {
        const queueData = queueSnapshot.val();
        queueIdToDelete = Object.keys(queueData)[0];
        targetPnL = Number(queueData[queueIdToDelete].pnl) || 0;
      } else {
        const randomLossPercent = (Math.random() * 0.20) + 0.10; 
        targetPnL = -(investAmount * randomLossPercent);
      }

      const durationSec = parseInt(time) * (time.includes('m') ? 60 : 1);
      const expiry = Date.now() + (durationSec * 1000);
      const tradeKey = push(ref(db, `activePositions/${userDbKey}`)).key;

      const finalUpdates = {};
      finalUpdates[`activePositions/${userDbKey}/${tradeKey}`] = {
        asset: coinSymbol || 'BTC/USDT',
        direction: direction === 'buy' ? 'Long' : 'Short',
        amount: investAmount,
        entryPrice: parseFloat(currentPrice) || 0,
        duration: durationSec,
        expiryTime: expiry,
        targetPnL: parseFloat(targetPnL.toFixed(2)),
        queueTradeId: queueIdToDelete, 
        currentLivePnL: 0,
        status: 'Active',
        createdAt: Date.now()
      };
      
      await update(ref(db), finalUpdates);
      setAmount('0.00');

    } catch (error) {
      alert("Error: " + error.message);
    } finally {
      setIsExecuting(false);
    }
  };

  const handlePercentClick = (p) => {
    const pct = parseInt(p) / 100;

    // ✅ FIX: live balance use karo
    setAmount(((walletBalance + totalLivePnL) * pct).toFixed(2));
  };

  return (
    <div className="trade-panel-white">
      <div className="panel-label">Expiration Time</div>
      <div className="selection-grid">
        {['30s', '40s', '60s', '2m', '5m'].map(t => (
          <button key={t} className={`white-opt ${time === t ? 'selected' : ''}`} onClick={() => setTime(t)}>{t}</button>
        ))}
      </div>

      <div className="label-row">
        <span className="panel-label">Investment Amount</span>

        {/* ✅ FIX: live balance show karo */}
        <span className="available-label">
          Available: <span className="balance-highlight">
            {(walletBalance + totalLivePnL).toFixed(2)} USDT
          </span>
        </span>
      </div>

      <div className="input-box">
        <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} />
      </div>
      
      <div className="selection-grid percent-row">
        {['5%', '20%', '50%', '80%', '100%'].map(p => (
          <button key={p} className="white-opt" onClick={() => handlePercentClick(p)}>{p}</button>
        ))}
      </div>

      <div className="action-row">
        <button className="buy-btn" disabled={isExecuting} onClick={() => handleTradeAction('buy')}>Buy / Long</button>
        <button className="sell-btn" disabled={isExecuting} onClick={() => handleTradeAction('sell')}>Sell / Short</button>
      </div>
    </div>
  );
};

export default TradePanel;